/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BaseStore<T extends Record<string, any>> {
  private readonly appState = signal<T>({} as T);

  // Set a new state
  setState(value: T): void {
    this.appState.set({...value});
  }

  // Get all state
  getState(): T {
    return this.appState();
  }

  // Select partial state based on key
  selectPartialState(key: string): any {
    try {
      const state: Record<string, any> = this.appState();
      return state[key];
    } catch (error) {
      console.error('Error in getting state', error);
    }
  }

  // Method to update entire state
  updateState(newState: T): void {
    this.appState.update((state) => {
      console.log(state, newState);
      const finalState = {...state, ...newState};
      return finalState;
    });
  }

  // Update partial
  updatePartialState(key: string, newValue: any): void {
    this.appState.update((state) => {
      return {
        ...state,
        [key]: newValue,
      };
    });
  }
}
